  import React, { useEffect, useState } from "react";

  export default function CampaignPickerModal({
    open,
    onClose,
    apiFetch,
    selectedRows,
    onAdded,
  }) {
    const [loading, setLoading] = useState(false);
    const [campaigns, setCampaigns] = useState([]);
    const [picked, setPicked] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
      if (!open) return;
      (async () => {
        setError("");
        setLoading(true);
        try {
          const j = await apiFetch("/api/email/campaigns", { credentials: "include" });
          setCampaigns(Array.isArray(j.items) ? j.items : []);
        } catch (e) {
          setError(e?.message || "Failed to load campaigns");
        } finally {
          setLoading(false);
        }
      })();
    }, [open, apiFetch]);

    const addNow = async () => {
    if (!picked) return;

    const rawRows = (selectedRows || []).filter(
      (r) => r.email && r.email.trim()
    );
    if (rawRows.length === 0) {
      onClose?.();
      return;
    }

    // 🔧 Normalize shapes from "revealed" vs search/db results
    const rows = rawRows.map((r) => {
      const playlist_id =
        r.playlist_id || r.id || r.meta?.playlist_id || "";
      const playlist_name =
        r.playlist_name || r.name || r.meta?.playlist_name || "";
      const playlist_url =
        r.playlist_url || r.url || r.meta?.playlist_url || "";
      const curator_name =
        r.curator_name || r.curator || r.meta?.curator_name || "";
      const ig_handle =
        r.ig_handle || r.ig || r.meta?.ig_handle || null;

      return {
        email: r.email.trim(),
        playlist_id,
        playlist_name,
        playlist_url,
        curator_name,
        ig_handle,
        // optional: if you want to send meta explicitly as well
        // meta: {
        //   playlist_id,
        //   playlist_name,
        //   playlist_url,
        //   curator_name,
        //   ig_handle,
        // },
      };
    });

    setLoading(true);
    setError("");
    try {
      await apiFetch(`/api/email/campaigns/${picked}/recipients`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ recipients: rows }),
      });
      onAdded?.({ campaignId: picked, addedCount: rows.length });
      onClose?.();
    } catch (e) {
      setError(e?.message || "Failed to add recipients");
    } finally {
      setLoading(false);
    }
  };


    if (!open) return null;

    return (
      <div className="psl-modal-overlay" role="dialog" aria-modal="true" aria-label="Add to campaign">
        <div className="psl-modal" style={{ minWidth: 420 }}>
          <h3>Add selected to campaign</h3>
          <p style={{ marginTop: 6 }}>
            {selectedRows.length} selected • {selectedRows.filter(r => r.email?.trim()).length} with email
          </p>

          <div style={{ marginTop: 10, display: "grid", gap: 8, maxHeight: 260, overflow: "auto" }}>
            {loading && <div>Loading campaigns…</div>}
            {error && <div style={{ color: "#9b1c1c" }}>{error}</div>}

            {campaigns.map(c => (
              <label key={c.id} className="psl-cardrow" style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                  type="radio"
                  name="pick-campaign"
                  checked={picked === c.id}
                  onChange={() => setPicked(c.id)}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600 }}>{c.name}</div>
                  <div style={{ fontSize: 12, opacity: 0.8 }}>
                    #{c.id} • {c.status}
                    {" • "}Queued {c.queued} / Emailed {c.emailed} / Replied {c.replied} / Bounced {c.bounced}
                  </div>
                </div>
              </label>
            ))}

            {!loading && campaigns.length === 0 && <div>No campaigns yet. Create one first.</div>}
          </div>

          <div className="psl-modal-actions" style={{ marginTop: 14, display: "flex", gap: 8 }}>
            <button className="psl-btn" onClick={onClose}>Cancel</button>
            <button className="psl-btn primary" disabled={!picked || loading} onClick={addNow}>
              {loading ? "Adding…" : "Add to Campaign"}
            </button>
          </div>
        </div>
      </div>
    );
  }
